module.exports = __webpack_public_path__ + "img/nighthawks_1200px.1256ae15.png";